module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAABSklEQVRYR+3XUU6DQBAG4H/Cch+NPmiE6AHoW/EoegITPUh7ikZpKX0B9TT1rYzZpk3U6AM7MwkxyzOQj//fhYEw8oNG7kMEShuKCcYEpQlIr//fa7Batw/OpYvs4uRFmtRf1wcnWNXtE4juAHw45worZDhw05XoMQfg9ki4Isv0kwwG+kqqb0jaAjy5yc5V6xYBPbLevJe7fndIUh8pBlojVYCWSDWgFVIV6JHL9estg2eH3b1NkqTIL0+r0PekOlAbaQL8FclJkefDkzQDrpp2ykxzBlL/IieiyfXV2fPQqk2AWjj/MOpATZw6UBunClw1b1PmXrzmfq5RlYqruiuJMDtuCM3xSwy0xIkrtsaJgH4WpN6m1q/rMLjiZdM9MuN+tCP/fqL2P01IFxaj/jHF4ASHfrJCz4/A0ORixdLkYoIxQa0EpPf5BA10syktG4qtAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./packages/appletView/src/static/img/icons/arrow-right.png
// module id = 4gm4
// module chunks = 1